/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ email: NonNullable<unknown> }} Legal_ContactInputs */

const en_legal_contact = /** @type {(inputs: Legal_ContactInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Questions? Email ${i?.email}.`)
};

const id_legal_contact = /** @type {(inputs: Legal_ContactInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ada pertanyaan? Kirim email ke ${i?.email}.`)
};

/**
* | output |
* | --- |
* | "Questions? Email {email}." |
*
* @param {Legal_ContactInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const legal_contact = /** @type {((inputs: Legal_ContactInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Legal_ContactInputs, { locale?: "en" | "id" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_legal_contact(inputs)
	return en_legal_contact(inputs)
});